"use client";

import { useQuery } from "@tanstack/react-query";
import { browserCoreApi } from "@/lib/api";
import { categoryKeys } from "./query-keys";

export function useCategoryDetail(id: number) {
  return useQuery({
    queryKey: categoryKeys.detail(id),
    queryFn: ({ signal }) => browserCoreApi.categories.detail(id, signal),
  });
}

export function useCategoryChildren(id: number) {
  return useQuery({
    queryKey: categoryKeys.children(id),
    queryFn: ({ signal }) => browserCoreApi.categories.list({ parentId: id }, signal),
  });
}

export function useCategorySongs(id: number) {
  return useQuery({
    queryKey: categoryKeys.songs(id),
    queryFn: ({ signal }) => browserCoreApi.songs.list({ categoryId: id, limit: 40 }, signal),
  });
}
